<template lang="pug">
.app-card.overflow-x-auto.restaurants-styled-panel
  //- Header con título e ícono
  .d-flex.align-items-center.justify-content-between.tw-mb-3.tw-pb-2.tw-border-b.tw-border-gray-200.panel-header-responsive
    .d-flex.align-items-center.tw-gap-2.flex-wrap
      i.fa-solid.fa-store.tw-text-purple-600
      span.tw-font-semibold.tw-text-gray-700 {{ $I18n.t('vue.subsidaries_detail_table_panel.title') }}
      span.tw-bg-purple-100.tw-text-purple-700.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium {{ items.length }}
    create-subsidary-modal(
      :data-id='record.id' 
      :data-customer='dataCustomer'
      :data-model='record.model'
      :data-note-kind-visible='dataNoteKindVisible'
      :data-invoice-target='dataInvoiceTarget'
    )

  //- Tabla mejorada - Vista de escritorio
  .table-responsive.d-none.d-lg-block(v-if="!emptyItems")
    table.table.table-hover.restaurants-styled-table
      thead
        tr
          th.tw-text-center(style="width: 40px;") #
          th(style="width: 220px;") {{ $I18n.t('vue.subsidaries_detail_table_panel.table_name') }}
          th.tw-text-center(style="width: 80px;") Status
          th(style="width: 120px;")
            i.fa-solid.fa-map-marker-alt.tw-text-gray-400.tw-text-xs.tw-mr-1
            | City
          th(style="width: 140px;")
            i.fa-solid.fa-phone.tw-text-gray-400.tw-text-xs.tw-mr-1
            | Phone
          th.tw-text-center(style="width: 80px;")
            i.fa-solid.fa-wind.tw-text-gray-400.tw-text-xs.tw-mr-1
            | Hoods
          th.tw-text-center(style="width: 80px;")
            i.fa-solid.fa-clipboard-list.tw-text-gray-400.tw-text-xs.tw-mr-1
            | Orders
          th.tw-text-center(style="width: 100px;") Actions
      tbody
        tr(v-for="(item, index) in items" :key="item.id" :class="getRowClass(item)")
          //- Número
          td.tw-text-center.tw-text-gray-400 {{ index + 1 }}
          //- Name
          td
            .d-flex.align-items-center.tw-gap-2
              .tw-w-9.tw-h-9.tw-rounded-full.d-flex.align-items-center.justify-content-center.tw-flex-shrink-0(:class="item.is_active ? 'tw-bg-purple-100' : 'tw-bg-gray-200'")
                i.fa-solid.fa-store.tw-text-sm(:class="item.is_active ? 'tw-text-purple-600' : 'tw-text-gray-400'")
              .d-flex.flex-column
                span.tw-font-medium.tw-text-gray-800(v-if="item.aka") {{ item.aka }}
                span.tw-text-sm(:class="item.aka ? 'tw-text-gray-500' : 'tw-text-gray-800 tw-font-medium'") {{ item.name }}
          //- Status
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded-full.tw-text-xs.tw-font-medium(
              :class="item.is_active ? 'tw-bg-green-100 tw-text-green-700' : 'tw-bg-red-100 tw-text-red-700'"
            )
              i.tw-mr-1(:class="item.is_active ? 'fa-solid fa-check' : 'fa-solid fa-times'")
              | {{ item.is_active ? 'Active' : 'Inactive' }}
          //- City
          td
            .d-flex.align-items-center.tw-gap-1(v-if="item.city && item.city.name")
              i.fa-solid.fa-map-marker-alt.tw-text-blue-400.tw-text-xs
              span.tw-text-sm {{ item.city.name }}
            span.tw-text-gray-400.tw-text-xs(v-else) —
          //- Phone
          td
            .d-flex.align-items-center.tw-gap-1(v-if="item.phone && item.phone.number")
              i.fa-solid.fa-phone.tw-text-green-400.tw-text-xs
              span.tw-text-sm.tw-font-mono {{ item.phone.number }}
            span.tw-text-gray-400.tw-text-xs(v-else) —
          //- Hoods count
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-font-medium(
              v-if="item.hoods_count > 0"
              class="tw-bg-amber-100 tw-text-amber-700"
            )
              i.fa-solid.fa-wind.tw-mr-1
              | {{ item.active_hoods_count }}/{{ item.hoods_count }}
            span.tw-text-gray-400.tw-text-xs(v-else) 0
          //- Orders count
          td.tw-text-center
            span.tw-px-2.tw-py-1.tw-rounded.tw-text-xs.tw-font-medium(
              v-if="item.orders_count > 0"
              class="tw-bg-blue-100 tw-text-blue-700"
            )
              i.fa-solid.fa-clipboard-list.tw-mr-1
              | {{ item.orders_count }}
            span.tw-text-gray-400.tw-text-xs(v-else) 0
          //- Actions
          td.tw-text-center
            .d-flex.justify-content-center.tw-gap-1
              delete-subsidary-modal(
                :data-id='item.id'
                @deleted='retrieveCustomers'
              )
              app-icon-link(
                data-kind="link",
                :href="item.paths.show"
                data-icon="fa-solid fa-eye",
                data-label="",
                :data-title="$I18n.t('vue.subsidaries_detail_table_panel.view_restaurant')"
              )

  //- Vista de tarjetas para tablet y móvil
  .d-lg-none(v-if="!emptyItems")
    .restaurants-card-list
      .restaurant-card.mb-2(v-for="(item, index) in items" :key="'card-'+item.id" :class="{'inactive-card': !item.is_active}")
        .restaurant-card-header
          .d-flex.align-items-center.tw-gap-2.flex-grow-1
            .tw-w-10.tw-h-10.tw-rounded-full.d-flex.align-items-center.justify-content-center.tw-flex-shrink-0(:class="item.is_active ? 'tw-bg-purple-100' : 'tw-bg-gray-200'")
              i.fa-solid.fa-store(:class="item.is_active ? 'tw-text-purple-600' : 'tw-text-gray-400'")
            .flex-grow-1.min-width-0
              .d-flex.align-items-center.tw-gap-2.flex-wrap
                span.tw-font-semibold.tw-text-gray-800.text-truncate(v-if="item.aka") {{ item.aka }}
                span.tw-px-2.tw-py-0.tw-rounded-full.tw-text-xs.tw-font-medium(
                  :class="item.is_active ? 'tw-bg-green-100 tw-text-green-700' : 'tw-bg-red-100 tw-text-red-700'"
                )
                  | {{ item.is_active ? 'Active' : 'Inactive' }}
              .tw-text-sm.tw-text-gray-500.text-truncate {{ item.name }}
          .restaurant-card-actions
            delete-subsidary-modal(
              :data-id='item.id'
              @deleted='retrieveCustomers'
            )
            a.btn.btn-sm.btn-outline-primary(:href="item.paths.show")
              i.fa-solid.fa-eye
        
        .restaurant-card-body
          .row.g-2
            .col-6.col-md-3
              .info-item
                i.fa-solid.fa-map-marker-alt.tw-text-blue-400
                span(v-if="item.city && item.city.name") {{ item.city.name }}
                span.tw-text-gray-400(v-else) —
            .col-6.col-md-3
              .info-item
                i.fa-solid.fa-phone.tw-text-green-400
                span(v-if="item.phone && item.phone.number") {{ item.phone.number }}
                span.tw-text-gray-400(v-else) —
            .col-6.col-md-3
              .info-item
                i.fa-solid.fa-wind.tw-text-amber-400
                span(v-if="item.hoods_count > 0") {{ item.active_hoods_count }}/{{ item.hoods_count }} hoods
                span.tw-text-gray-400(v-else) 0 hoods
            .col-6.col-md-3
              .info-item
                i.fa-solid.fa-clipboard-list.tw-text-blue-400
                span(v-if="item.orders_count > 0") {{ item.orders_count }} orders
                span.tw-text-gray-400(v-else) 0 orders

  //- Estado vacío mejorado
  .tw-text-center.tw-py-8(v-if='emptyItems')
    .tw-w-16.tw-h-16.tw-bg-purple-100.tw-rounded-full.d-flex.align-items-center.justify-content-center.tw-mx-auto.tw-mb-3
      i.fa-solid.fa-store.tw-text-purple-400.tw-text-2xl
    p.tw-text-gray-500.tw-mb-0 {{ $I18n.t('vue.subsidaries_detail_table_panel.empty_items') }}
</template>

<script>
import CreateSubsidaryModal from './create-subsidary-modal.vue';
import DeleteSubsidaryModal from './delete-subsidary-modal.vue'
import CoreComponents from "../core";
import { BackendService } from "../../services";

export default {
  props: {
    dataId: String,
    dataCustomer: String,
    dataModel: String,
    dataItems: String,
    dataNoteKindVisible: String,
    dataInvoiceTarget: String,
  },
  components:{
    'create-subsidary-modal': CreateSubsidaryModal,
    'delete-subsidary-modal': DeleteSubsidaryModal,
    "app-icon-link": CoreComponents.AppIconLink,
  },
  data: function () {
    return {
      record: {
        id: this.dataId,
        model: this.dataModel,
      },
      items: JSON.parse(this.dataItems),
    };
  },
  computed: {
    emptyItems: function () {
      return this.items.length === 0;
    }
  },
  methods: {
    getRowClass: function(item) {
      if (item && !item.is_active) return "tw-bg-gray-50 tw-opacity-70";
      return "";
    },
    retrieveCustomers: function () {
    }
  }
};
</script>

<style scoped>
.restaurants-styled-panel {
  padding: 1rem;
  background: white;
  border-radius: 0.375rem;
}

.restaurants-styled-table {
  font-size: 0.85rem;
  margin-bottom: 0;
}

.restaurants-styled-table thead th {
  white-space: nowrap;
  vertical-align: middle;
  padding: 0.5rem 0.75rem;
  background-color: #f8f9fa;
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
  color: #495057;
}

.restaurants-styled-table tbody td {
  vertical-align: middle;
  padding: 0.5rem 0.6rem;
}

.restaurants-styled-table tbody tr:hover {
  background-color: rgba(139, 92, 246, 0.05);
}

/* Avatar circular */
.tw-w-9 {
  width: 2.25rem;
}
.tw-h-9 {
  height: 2.25rem;
}
</style>